'use client';
import React, { useState } from 'react';
import { Pencil } from 'lucide-react';
export default function MessageTemplatesManager() {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isActive, setIsActive] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  // --- MOCK DATA (52 items) ---
  const templates = [
    // Page 1
    { name: 'Blog.BlogComment', subject: '%Store.Name%. New blog comment.', active: true },
    { name: 'Customer.BackInStock', subject: '%Store.Name%. Back in stock notification', active: true },
    { name: 'Customer.EmailRevalidationMessage', subject: '%Store.Name%. Email validation', active: true },
    { name: 'Customer.EmailValidationMessage', subject: '%Store.Name%. Email validation', active: true },
    { name: 'Customer.Gdpr.DeleteRequest', subject: '%Store.Name%. New request to delete customer (GDPR)', active: true },
    { name: 'Customer.NewOrderNote', subject: '%Store.Name%. New order note has been added', active: true },
    { name: 'Customer.NewPM', subject: '%Store.Name%. You have received a new private message', active: true },
    { name: 'Customer.PasswordRecovery', subject: '%Store.Name%. Password recovery', active: true },
    { name: 'Customer.WelcomeMessage', subject: 'Welcome to %Store.Name%', active: true },
    { name: 'Forums.NewForumPost', subject: '%Store.Name%. New Post Notification.', active: true },
    { name: 'Forums.NewForumTopic', subject: '%Store.Name%. New Topic Notification.', active: true },
    { name: 'GiftCard.Notification', subject: '%GiftCard.SenderName% has sent you a gift card for %Store.Name%', active: true },
    { name: 'NewCustomer.Notification', subject: '%Store.Name%. New customer registration', active: true },
    { name: 'NewReturnRequest.CustomerNotification', subject: '%Store.Name%. New return request.', active: true },
    { name: 'NewReturnRequest.StoreOwnerNotification', subject: '%Store.Name%. New return request.', active: true },
    // Page 2
    { name: 'News.NewsComment', subject: '%Store.Name%. New news comment.', active: true },
    { name: 'NewsLetterSubscription.ActivationMessage', subject: '%Store.Name%. Subscription activation message.', active: true },
    { name: 'NewsLetterSubscription.DeactivationMessage', subject: '%Store.Name%. Subscription deactivation message.', active: true },
    { name: 'NewVATSubmitted.StoreOwnerNotification', subject: '%Store.Name%. New VAT number is submitted.', active: true },
    { name: 'OrderCancelled.CustomerNotification', subject: '%Store.Name%. Your order cancelled', active: true },
    { name: 'OrderCancelled.VendorNotification', subject: '%Store.Name%. Order #%Order.OrderNumber% cancelled', active: true },
    { name: 'OrderCompleted.CustomerNotification', subject: '%Store.Name%. Your order completed', active: true },
    { name: 'OrderPaid.AffiliateNotification', subject: '%Store.Name%. Order #%Order.OrderNumber% paid', active: true },
    { name: 'OrderPaid.CustomerNotification', subject: '%Store.Name%. Order #%Order.OrderNumber% paid', active: true },
    { name: 'OrderPaid.StoreOwnerNotification', subject: '%Store.Name%. Order #%Order.OrderNumber% paid', active: true },
    { name: 'OrderPaid.VendorNotification', subject: '%Store.Name%. Order #%Order.OrderNumber% paid', active: true },
    { name: 'OrderPlaced.AffiliateNotification', subject: '%Store.Name%. Order placed', active: true },
    { name: 'OrderPlaced.CustomerNotification', subject: 'Order receipt from %Store.Name%.', active: true },
    { name: 'OrderPlaced.StoreOwnerNotification', subject: '%Store.Name%. Purchase Receipt for Order #%Order.OrderNumber%', active: true },
    { name: 'OrderPlaced.VendorNotification', subject: '%Store.Name%. Order placed', active: true },
    // Page 3
    { name: 'OrderProcessing.CustomerNotification', subject: '%Store.Name%. Your order is processing', active: true },
    { name: 'OrderRefunded.CustomerNotification', subject: '%Store.Name%. Order #%Order.OrderNumber% refunded', active: true },
    { name: 'OrderRefunded.StoreOwnerNotification', subject: '%Store.Name%. Order #%Order.OrderNumber% refunded', active: true },
    { name: 'Product.ProductReview', subject: '%Store.Name%. New product review.', active: true },
    { name: 'ProductReview.Reply.CustomerNotification', subject: '%Store.Name%. Product review reply.', active: true },
    { name: 'QuantityBelow.AttributeCombination.StoreOwnerNotification', subject: '%Store.Name%. Quantity below notification. %Product.Name%', active: true },
    { name: 'QuantityBelow.AttributeCombination.VendorNotification', subject: '%Store.Name%. Quantity below notification. %Product.Name%', active: true },
    { name: 'QuantityBelow.StoreOwnerNotification', subject: '%Store.Name%. Quantity below notification. %Product.Name%', active: true },
    { name: 'QuantityBelow.VendorNotification', subject: '%Store.Name%. Quantity below notification. %Product.Name%', active: true },
    { name: 'RecurringPaymentCancelled.CustomerNotification', subject: '%Store.Name%. Recurring payment cancelled', active: true },
    { name: 'RecurringPaymentCancelled.StoreOwnerNotification', subject: '%Store.Name%. Recurring payment cancelled', active: true },
    { name: 'RecurringPaymentFailed.CustomerNotification', subject: '%Store.Name%. Last recurring payment failed', active: true },
    { name: 'ReturnRequestStatusChanged.CustomerNotification', subject: '%Store.Name%. Return request status was changed.', active: true },
    { name: 'Service.ContactUs', subject: '%Store.Name%. Contact us', active: true },
    { name: 'Service.ContactVendor', subject: '%Store.Name%. Contact us', active: true },
    // Page 4
    { name: 'Service.EmailAFriend', subject: '%Store.Name%. Referred Item', active: true },
    { name: 'ShipmentDelivered.CustomerNotification', subject: 'Your order from %Store.Name% has been delivered.', active: true },
    { name: 'ShipmentReadyForPickup.CustomerNotification', subject: 'Your order from %Store.Name% is ready for pickup.', active: true },
    { name: 'ShipmentSent.CustomerNotification', subject: 'Your order from %Store.Name% has been shipped.', active: true },
    { name: 'VendorAccountApply.StoreOwnerNotification', subject: '%Store.Name%. New vendor account submitted.', active: true },
    { name: 'VendorInformationChange.StoreOwnerNotification', subject: '%Store.Name%. Vendor information change.', active: true },
    { name: 'Wishlist.EmailAFriend', subject: '%Store.Name%. Wishlist', active: true },
  ];
  // Filter + pagination logic
  const filtered = templates.filter((t) =>
    t.name.toLowerCase().includes(searchKeyword.toLowerCase())
  );
  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const displayed = filtered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  return (
    <div className="p-4 md:p-6 bg-gray-100 min-h-screen">
      <div className="bg-white rounded-lg shadow-sm p-4 md:p-6">
        <h1 className="text-lg font-semibold mb-4 border-b pb-2">Message templates</h1>
        {/* Search section */}
        <div className="bg-gray-50 border p-4 rounded mb-4">
          <div className="flex flex-col md:flex-row md:items-center md:space-x-4 space-y-3 md:space-y-0">
            <div className="flex items-center w-full md:w-auto">
              <span className="mr-2 text-gray-600">🔍</span>
              <label className="text-sm font-medium mr-2">Search keywords</label>
              <input
                type="text"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                className="border rounded px-2 py-1 w-full md:w-64"
              />
            </div>
            <div className="flex items-center w-full md:w-auto">
              <label className="text-sm font-medium mr-2">Is active</label>
              <select
                value={isActive}
                onChange={(e) => setIsActive(e.target.value)}
                className="border rounded px-2 py-1 w-full md:w-40"
              >
                <option>All</option>
                <option>Active</option>
                <option>Inactive</option>
              </select>
            </div>
            <button
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
              onClick={() => setCurrentPage(1)}
            >
              Search
            </button>
          </div>
        </div>
        <p className="text-sm text-gray-500 mb-3">
          Learn more about <a href="#" className="text-blue-600 underline">message templates</a>
        </p>
        {/* Table */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="bg-gray-200 text-left">
                <th className="p-2 border">Name</th>
                <th className="p-2 border">Subject</th>
                <th className="p-2 border text-center">Is active</th>
                <th className="p-2 border">Limited to stores</th>
                <th className="p-2 border text-center">Edit</th>
              </tr>
            </thead>
            <tbody>
              {displayed.map((t, i) => (
                <tr key={i} className="odd:bg-white even:bg-gray-50 hover:bg-blue-50">
                  <td className="p-2 border">{t.name}</td>
                  <td className="p-2 border">{t.subject}</td>
                  <td className="p-2 border text-center">{t.active ? '✔️' : ''}</td>
                  <td className="p-2 border">All stores</td>
                  <td className="p-2 border text-center">
                    <button className="flex items-center justify-center text-blue-600 hover:text-blue-800">
                      <Pencil size={16} /> <span className="ml-1">Edit</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="flex flex-col md:flex-row md:justify-between items-center mt-4 space-y-2 md:space-y-0">
          <div className="flex items-center space-x-2">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              className="border px-3 py-1 rounded disabled:opacity-50"
            >
              Previous
            </button>
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentPage(i + 1)}
                className={`border px-3 py-1 rounded ${
                  currentPage === i + 1 ? 'bg-blue-600 text-white' : ''
                }`}
              >
                {i + 1}
              </button>
            ))}
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
              className="border px-3 py-1 rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>

          <div className="text-sm text-gray-500">
            Show <select className="border rounded px-1 py-0.5"><option>15</option></select> items
          </div>
        </div>

        <p className="text-xs text-gray-500 text-right mt-2">
          {((currentPage - 1) * itemsPerPage) + 1}-{Math.min(currentPage * itemsPerPage, filtered.length)} of {filtered.length} items
        </p>
      </div>
    </div>
  );
}
